import router from '@/router';

const CURRENT_DEALERSHIP_KEY = 'current_dealership';

export default {
  namespaced: true,
  state: {
    currentAssessment: null,
    currentDealership: null,
    reviewing: false,
    trt: [],
  },
  mutations: {
    setReviewing(state, reviewing) {
      state.reviewing = reviewing;
    },
    setCurrentAssessment(state, assessment) {
      state.currentAssessment = assessment;
    },
    setCurrentDealership(state, dealership) {
      if (dealership) {
        dealership.search_key = `${dealership.pa} ${dealership.dealer_name}`;

        if (state.currentDealership !== null) {
          if (!dealership) {
            router.push({ name: 'DealershipSelection' });
            this.setTRT(null);
          }
        }

        localStorage.setItem(
          CURRENT_DEALERSHIP_KEY,
          JSON.stringify(dealership)
        );
        state.currentDealership = dealership;
      } else {
        state.currentDealership = null;
        localStorage.setItem(CURRENT_DEALERSHIP_KEY, null);
      }
    },
    getCurrentDealership(state) {
      let currentDealership = null;

      try {
        currentDealership = JSON.parse(
          localStorage.getItem(CURRENT_DEALERSHIP_KEY)
        );
      } catch (error) {
        console.error('Error accessing localStorage:', error);
      }

      if (currentDealership) {
        currentDealership.search_key = `${currentDealership.pa} ${currentDealership.dealer_name}`;
        state.currentDealership = currentDealership;
      }

      return null;
    },
    setTRT(state, trt) {
      state.trt = trt;
    },
  },
  strict: process.env.NODE_ENV !== 'production',
};
